import { render, staticRenderFns } from "./KonvaCampaignCanvas.vue?vue&type=template&id=10358888&scoped=true"
import script from "./KonvaCampaignCanvas.vue?vue&type=script&lang=js"
export * from "./KonvaCampaignCanvas.vue?vue&type=script&lang=js"
import style0 from "./KonvaCampaignCanvas.vue?vue&type=style&index=0&id=10358888&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10358888",
  null
  
)

export default component.exports